import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { BuildMetricsRecord } from './buildMetrics.types'
import { getBuildMetrics } from './buildMetrics'

export const useGetBuildMetrics = (
  app: string | null | undefined
): UseQueryResult<Array<BuildMetricsRecord>> => {
  return useQuery({
    queryKey: ['build-metrics', app],
    queryFn: () => getBuildMetrics(app ?? ''),
    enabled: Boolean(app),
  })
}
